import { Component } from '@angular/core';
import { TicketContextService } from '../../services/ticket-context.service';


@Component({
  selector: 'app-ticket-page',
  templateUrl: './ticket-page.component.html',
  styleUrls: ['./ticket-page.component.scss']
})
export class TicketPageComponent {

constructor(private ticketContextService: TicketContextService){}
  
  public isTicketSelected = (): boolean => {
    if (this.ticketContextService.ticket && this.ticketContextService.ticket.ticketId) {
        return true;
    }
    return false;
}
  
}

